import React, {useState} from 'react';

import {Alert} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';

import {useAuth} from '../../../../context/auth';

import {Button} from '../../../../components/Interface/Forms/Buttons/Button';
import {Header} from '../../../../components/Interface/Headers/Header';
import {Loading} from '../../../../components/Interface/Loadings/Loading';

import {api} from '../../../../services/api';

import {Container, Content, LottieContainer, Footer} from './styles';
import {Toast} from '../../../../components/Interface/Toast';
import {Titles} from '../../../../components/Interface/Typographies/Titles';
import {useNavigation} from '@react-navigation/native';


export function DeleteAccount() {
  const {signOut, user} = useAuth();
  const navigation = useNavigation();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);

  async function excluiConta() {
    setIsLoading(true);
    try {
      await api
        .delete('/users/' + user.user_id)

        .catch(() => {
          setError(true);

        })
        .finally(() => {
          setIsLoading(false);


          signOut();

          navigation.navigate('Initial');
        });
    } catch (err) {
      console.log(err);
      setError(true);
    }
  }

  function alertaExcluiConta() {
    Alert.alert(
      'Deseja excluir sua conta?',
      'Esta é uma ação permanente e irreversível.',
      [
        {
          text: 'Excluir conta',
          style: 'destructive',
          onPress: () => excluiConta(),
        },
        {
          text: 'Cancelar',
          style: 'cancel',
        },
      ],
    );
  }

  return (
    <Container>
      {isLoading && <Loading />}
      <Header icon="chevron-left" />
      {error && (
        <Toast
          type="error"
          text="Não foi possível excluir a conta"
          timeout={2000}
          onEnd={() => setError(false)}
        />
      )}
      <Content>
        <LottieContainer />
        <Titles
          title="Deseja encerrar a sua conta?"
          subtitle="Você não poderá mais acessar sua conta e seus dados serão excluídos em
          até 20 dias."
        />
      </Content>
      <Footer>
        <SafeAreaView>
          <Button
            title="Encerrar minha conta"
            enabled
            onPress={() => alertaExcluiConta()}
          />
        </SafeAreaView>
      </Footer>
    </Container>
  );
}
